'use strict';

import type { UserAppWebhook } from '../../Entities/User/UserAppWebhook';
import { EntityCollection } from '../EntityCollection';

export class UserAppWebhookCollection extends EntityCollection<UserAppWebhook> {}
